module.exports = __webpack_public_path__ + "static/media/canada.821a5df4.jpg";